import React, { useEffect, useRef, useState } from "react";
import { FileText, Phone, BriefcaseMedical, Hospital, MessageCircleQuestion, Stethoscope, Copy, Clock, CircleDot, CircleStop, Calendar, Lock, Printer, Clock9, SquareActivity, Ruler, ClipboardList, TriangleAlert, Pencil, Upload, X, Save, Loader, WandSparkles, Speech, CircleCheck, CircleMinus } from "lucide-react";
import { Drawer } from "vaul";
import { fetchSingleSignoutPatient } from "../../services/patient";
import { calculateAgeFromDOB, can_visit, copyToHtmlClipboard, exchangeDate, Gender, getDateString, getPractice, getSecureData, isMobileDevice, notify, setSecureData, userAccessToken } from "../../helpers";
import { Config } from "../../Config";
import { saveTranscriptionText, updatePostVisitNote, uploadChartToEHR } from "../../services/waitingRoom";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import Spacing from "../Spacing";
import AuditReporteditNote from "./AuditReporteditNote";
import AuditReportNoteViewModal from "./AuditReportNoteViewModal";
import { speech_phrases } from "../../helpers/constants";
import Skeleton from "react-loading-skeleton";
import SendEHRConfirm from "./SendEHRConfirm";
const maleAvatar = "./images/avatar.png";
const femaleAvatar = "./images/female.png";
const otherAvatar = "./images/other.png";

export default function AuditReportViewModal(props) {
  const {
    account_id,
    location_id,
    specility_id,
    waiting_room_id,
    active_modal,
    set_active_modal = () => { },
    setCallNoteCallType = () => { },
    setActiveCallNoteCallModal = () => { },
    handleSignOutSheet = () => { },
    waitingId,
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => { },
    setPreviousCallScrollPosition = () => { },
    setPostVisitLoaderId = () => { },
    setEnablePostVisitLoader = () => { },
    setPostVisitUploadEmrId = () => { },
  } = props;

  const [activeTab, setActiveTab] = useState(0);
  const dropdownRef = useRef(null);

  const [visitActive, setVisitActive] = useState("pre_visit");
  const [singlePatientData, setSinglePatientData] = useState([]);
  const [filteredConditions, setFilteredConditions] = useState([]);
  const [signOutPatientData, setSignOutPatientData] = useState([]);
  const [lastThreeVisitData, setLastThreeVisitData] = useState({});
  const [ancillaryServices, setAncillaryServices] = useState([]);
  const [lastWellnessDate, setLastWellnessDate] = useState("");
  const [previsitDos, setPrevisitDos] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [viewStatusOptions, setViewStatusOptions] = useState(false);
  const [transcription, setTranscription] = useState("");
  const [isRecognizing, setIsRecognizing] = useState(false);
  const [opacityClass, setOpacityClass] = useState("");
  const [transcriptQuestions, setTranscriptQuestions] = useState([]);
  // const [transcriptDiagnosis, setTranscriptDiagnosis] = useState([]);
  // const [specialityProfiles, setSpecialityProfiles] = useState([]);
  const [emptyDuringVisit, setEmptyDuringVisit] = useState(false);
  // const [showProcessingAnimation, setShowProcessingAnimation] = useState(false);
  // const [checkProcessingAnimation, setCheckProcessingAnimation] = useState("");
  const [emptyPotentialAncillaryServices, setEmptyPotentialAncillaryServices] = useState(false);
  const [postVisitData, setPostVisitData] = useState({});
  const mediaStreamRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const canvasRef = useRef(null);
  const recognizerRef = useRef(null);
  const dataArrayRef = useRef([]);
  const microphoneRef = useRef(null);
  const scriptProcessorRef = useRef(null);
  const [previsitRecordTimes, setPrevisitRecordTimes] = useState({});
  const [startTime, setStartTime] = useState(null);
  const [recordTime, setRecordTime] = useState(0);
  const speechTokenRef = useRef(null);
  const translateTokenRef = useRef(null);
  const transcriptionRef = useRef("");
  const startingTranscriptionRef = useRef("");
  const transcriptQuestionsRef = useRef([]);
  const transcriptDiagnosisRef = useRef([]);
  const previsitRecordTimesRef = useRef({});
  const [postvisitLoader, setPostvisitLoader] = useState(false);
  const [viewWarningText, setViewWarningText] = useState("");
  const [enableWarningView, setEnableWarningView] = useState(false);
  const timerRef = useRef(null);
  const [noteEditMode, setNoteEditMode] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [chechStartConversation, setChechStartConversation] = useState(false);
  const [viewNoteModal, setViewNoteModal] = useState(false);
  const [disabledCallBtn, setDisabledCallBtn] = useState(true);
  let user_id = getPractice("user_id");
  const noteRef = useRef();
  // const mediaAudioRecorderRef = useRef(null);
  // const mediaAudioChunksRef = useRef([]);
  const [startingConversation, setStartingConversation] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [pushEhrResult, setPushEhrResult] = useState({});
  const [disabledNoteGenerate, setDisabledNoteGenerate] = useState(false);
  const [enableClinicalNote, setEnableClinicalNote] = useState(false);
  const waitingIdRef = useRef(waiting_room_id);
  const modalOpenRef = useRef(false);
  const autoCallCountRef = useRef(0);
  const [showEHRPushWarning, setShowEHRPushWarning] = useState(false);
  const [pushEhrFlags, setPushEhrFlags] = useState({
    hpi_key: true,
    ros_key: true,
    pe_key: true,
    icd_key: true,
    assessment_key: true
  });

  useEffect(() => {
    modalOpenRef.current = !!active_modal;
    if (!active_modal) {
      try { if (timerRef.current) { clearInterval(timerRef.current); } } catch {}
    }
  }, [active_modal]);
  
  useEffect(() => { waitingIdRef.current = waiting_room_id; }, [waiting_room_id]);


  useEffect(() => {
    if (!active_modal) return;

    let previsitViewerWsURL = `${Config.apiServerUrl}/waiting_room/previsit_viewer/set-viewer?waiting_room_id=${waiting_room_id}&user_id=${user_id}&account_id=${account_id}&location_id=${location_id}`.replace(/^http(s?):/, "ws$1:");
    const previsitViewerSocket = new WebSocket(previsitViewerWsURL);

    previsitViewerSocket.onopen = () => { };
    return () => previsitViewerSocket.close();
  }, [active_modal, waiting_room_id, user_id, account_id, location_id]);

  const check_previsit_viewer = async () => {
    try {
      const response = await fetch(
        `${Config.apiServerUrl}/waiting_room/previsit_viewer/is-viewed?waiting_room_id=${waiting_room_id}&user_id=${user_id}&account_id=${account_id}&location_id=${location_id}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${userAccessToken() || ""}`,
          },
        }
      );

      const data = await response.json();

      if (data?.status === "success") {
        return data?.viewed_by_others;
      }
    } catch (error) {
      console.error("Error check_previsit_viewer:", error);
      return false;
    }
  };

  useEffect(() => {
    const checkViewer = async () => {
      const isViewed = await check_previsit_viewer();
      if (isViewed) {
        setEnableWarningView(true);
        setViewWarningText("DOCPROMD is currently viewing this patient. Only one user can generate/edit note at a time.");
      } else {
        setEnableWarningView(false);
        setViewWarningText("");
      }
    }
    checkViewer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchTokens();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active_modal]);

  // Return the token if still valid, else null.
  const getValidTokenOrNull = (token) => {
    if (!token || typeof token !== "string") return null;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const exp = payload?.exp;
      if (!exp) return null;
      const now = Math.floor(Date.now() / 1000);
      return now < exp ? token : null;
    } catch (_e) {
      return null;
    }
  };

  const fetchTokens = async (force = false, { maxRetries = 3 } = {}) => {
    try {
      let speech = null;
      let translate = null;
      if (!force) {
        const storedSpeech = await getSecureData("speech_token");
        const storedTranslate = await getSecureData("translate_token");
        speech = getValidTokenOrNull(storedSpeech);
        translate = getValidTokenOrNull(storedTranslate);
      }
      if (!speech || !translate) {
        let attempt = 0;
        let errLast;
        while (attempt < maxRetries && (!speech || !translate)) {
          attempt += 1;
          try {
            const response = await fetch(`${Config.apiServerUrl}/transcribe/token`, {
              method: "POST",
              headers: {
                accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${userAccessToken() || ""}`,
              },
            });
            const data = await response.json();
            if (data?.status === "success") {
              speech = data?.speech_token || null;
              translate = data?.translate_token || null;
              if (speech) await setSecureData("speech_token", speech);
              if (translate) await setSecureData("translate_token", translate);
            } else {
              console.error("Error fetching token:", data?.message);
            }
          } catch (e) {
            errLast = e
          }
          if ((!speech || !translate) && attempt < maxRetries) {
            await new Promise(res => setTimeout(res, 500 * attempt));
          }
        }
        if (!speech || !translate) {
          if (errLast) console.error("Token fetch error:", errLast);
        }
      }
      if (speech) speechTokenRef.current = speech;
      if (translate) translateTokenRef.current = translate;
    } catch (error) {
      console.error("Error retrieving token:", error);
    } finally {
      setDisabledCallBtn(false);
    }
  };

  // Returns true if token is valid for at least `minRemainingSec` seconds
  const checkRecorderToken = (token, minRemainingSec = 0) => {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const exp = payload?.exp;
      if (!exp) return false;
      const now = Math.floor(Date.now() / 1000);
      return (exp - now) > minRemainingSec;
    } catch (_e) {
      return false;
    }
  };

  const translateToEnglish = async (text, from) => {
    try {
      const resp = await fetch(`${Config.apiServerUrl}/transcribe/translate`, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${userAccessToken() || ""}`,
        },
        body: JSON.stringify({
          "text": text,
          "from_language": from
        })
      });
      const data = await resp.json();
      if (data.status === 'success') {
        return data.result || text;
      } else {
        console.error("Translate failed:", data);
        return text;
      }
    } catch (e) {
      console.error("translate error", e);
      return text;
    }
  };

  useEffect(() => {
    getSignOutPatient(account_id, location_id, waiting_room_id, false, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, location_id, waiting_room_id]);

  const getSignOutPatient = async (accountId, locationId, waitingRoomId, retry, loader) => {
    if (!modalOpenRef.current) { return; }
    if (waitingRoomId !== waitingIdRef.current) { return; }
    if (!modalOpenRef.current) { return; }

    const response = await fetchSingleSignoutPatient(accountId, locationId, waitingRoomId, retry, loader);

    if (response) {
      if (response.data === null) {
        set_active_modal(!active_modal);
        window.scrollTo(0, previousScrollPosition);
      }

      if (response?.data?.status === "success") {
        setSignOutPatientData(response?.data?.patient_data);
        setLastThreeVisitData(response?.data?.last_three_visits);
        setLastWellnessDate(response?.data?.last_annual_wellness_visit);
        if (Object?.keys(response?.data?.potential_ancillary_services)?.length > 0) {
          setAncillaryServices(response?.data?.potential_ancillary_services);
          setEmptyPotentialAncillaryServices(false);
        } else {
          if (
            response?.data?.patient_data?.chronic_conditions &&
            response?.data?.patient_data?.chronic_conditions.length > 0 &&
            (!response?.data?.potential_ancillary_services ||
              Object?.keys(response?.data?.potential_ancillary_services)
                .length === 0) && autoCallCountRef.current < 50 && modalOpenRef.current && waitingRoomId === waitingIdRef.current
          ) {
            setEmptyPotentialAncillaryServices(true);

            await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds
            if (!modalOpenRef.current || waitingRoomId !== waitingIdRef.current) { return; }
            autoCallCountRef.current = autoCallCountRef.current + 1;
            getSignOutPatient(account_id, location_id, waiting_room_id, false, false);
          }
        }
        setPrevisitRecordTimes(response?.data?.record_times || {});
        previsitRecordTimesRef.current = response?.data?.record_times || {};
        setPrevisitDos(response?.data?.dos);
        setTranscription(response?.data?.voice_transcribe || "");
        transcriptionRef.current = response?.data?.voice_transcribe || "";
        startingTranscriptionRef.current = response?.data?.voice_transcribe || "";
        if(response?.data?.voice_transcribe && response?.data?.voice_transcribe !== "") {
          setChechStartConversation(true);
        }
        setTranscriptQuestions(response?.data?.question_list || []);
        transcriptQuestionsRef.current = response?.data?.question_list || [];
        // setTranscriptDiagnosis(response?.data?.diagnosis_list || []);
        transcriptDiagnosisRef.current = response?.data?.diagnosis_list || [];
        // setSpecialityProfiles(response?.data?.speciality_profile || []);
        if (Object?.keys(response?.data?.post_visit_data ?? {})?.length > 0) {
          setPostVisitData(response?.data?.post_visit_data || {});
        } else {
          setEnableClinicalNote(true);
        }
        if (
          response?.data?.question_list?.length ||
          response?.data?.diagnosis_list?.length ||
          response?.data?.voice_transcribe
        ) {
          setEmptyDuringVisit(false);
        } else {
          setEmptyDuringVisit(true);
        }
        setIsDataLoaded(true);

        if (
          response?.data?.patient_data?.chronic_conditions &&
          response?.data?.patient_data?.chronic_conditions.length > 0
        ) {
          handleFilterConditions(response?.data?.patient_data?.chronic_conditions);
        }
        setSinglePatientData(response?.data);
      }
    }
  };

  const handleFilterConditions = (chronicConditions) => {
    const filteredData = chronicConditions?.reduce((acc, condition) => {
      const diseaseOrName = condition?.disease_name || condition?.name || "";
      if (!acc.some((c) =>
        c?.disease_name?.includes("Type 2 Diabetes") ||
        c?.name?.includes("Type 2 Diabetes")
      ) || !diseaseOrName?.includes("Type 2 Diabetes")
      ) {
        acc.push({
          ...condition,
          name: diseaseOrName?.includes("Type 2 Diabetes")
            ? "Type 2 Diabetes"
            : diseaseOrName,
        });
      }
      return acc;
    }, []);
    setFilteredConditions(filteredData);
  };

  const handleOutsideClick = (event) => {
    if (!event?.target?.closest(".dropdown-container")) {
      setViewStatusOptions(false);
    }
  };

  useEffect(() => {
    document?.addEventListener("click", handleOutsideClick);
    return () => {
      document?.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleCall = (callType) => {
    setCallNoteCallType(callType);
    setActiveCallNoteCallModal(true);
    setViewStatusOptions(false);
    set_active_modal(!active_modal);
    window.scrollTo(0, previousScrollPosition);
    setPreviousCallScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    return () => clearInterval(timerRef.current);
  }, []);

  const formatRecordingTime = (totalSeconds) => {
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const secs = String(totalSeconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  const toggleRecording = async () => {
    if (!isRecognizing) {
      setStartingConversation(true);
      // Check and refresh token if expired
      if (!speechTokenRef.current || !checkRecorderToken(speechTokenRef.current, 8)) {
        await fetchTokens(true);
        if (!speechTokenRef.current) {
          notify("error", "Unable to fetch token. Please try again later.", 2);
          setStartingConversation(false);
          return;
        }
      }

      // Start recognition with auto language detection
      const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(speechTokenRef.current, "eastus");
      // Set higher quality settings for speech recognition
      speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, "600000");
      speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, "10000");
      speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");

      // Create AutoDetectSourceLanguageConfig with the desired languages
      const autoDetectSourceLanguageConfig = SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([
        "en-US", "es-ES", "es-CO", "he-IL", "ru-RU", "bn-IN"
      ]);

      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      recognizerRef.current = SpeechSDK.SpeechRecognizer.FromConfig(
        speechConfig, autoDetectSourceLanguageConfig, audioConfig
      );
      const phraseListGrammar = SpeechSDK.PhraseListGrammar.fromRecognizer(recognizerRef.current);
      speech_phrases.forEach((phrase) => phraseListGrammar.addPhrase(phrase));

      setChechStartConversation(true);
      setStartTime(Date.now()); // Start timer
      setRecordTime(0); // reset timer
      timerRef.current = setInterval(() => {
        setRecordTime((prev) => prev + 1);
        // Check token expiration every 30 seconds
        if (recordTime % 30 === 0) {
          const callTimeChecker = checkRecorderToken(speechTokenRef.current, 8);
          if (callTimeChecker === false) {
            fetchTokens(true);
          }
        }
      }, 1000);
      if(!can_visit('ehr_veradigm')) {
        setVisitActive("during_visit");
      }
      setActiveTab(0);


      let didRecognize = false;
      recognizerRef.current.recognized = async (s, e) => {
        if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
          didRecognize = true;
          const languageDetectionResult = SpeechSDK.AutoDetectSourceLanguageResult.fromResult(e.result);
          const detectedLanguage = languageDetectionResult.language;
          let finalText = e.result.text;

          if (detectedLanguage !== "en-US") {
            finalText = await translateToEnglish(finalText, detectedLanguage);
          }

          // Check token expiration during recognition
          const callTimeChecker = checkRecorderToken(speechTokenRef.current, 8);
          if (callTimeChecker === false) {
            await fetchTokens(true);
          }

          if (finalText) {
            setTranscription((prev) => prev + `${finalText}\n`);
            transcriptionRef.current = transcriptionRef.current + `${finalText}\n`;
            setEmptyDuringVisit(false);
            setSecureData("ideal_using_mic_time", Math.floor(Date.now() / 1000))
          }
        }
      };

      recognizerRef.current.canceled = (s, e) => {
        console.error("Recognition error:", e.errorDetails);
        recognizerRef.current?.stopContinuousRecognitionAsync();
        setIsRecognizing(false);
        if ((e.reason === SpeechSDK.CancellationReason.Error) && (e.errorDetails?.includes("StatusCode: 1006"))) {
          notify("error", "Network issue: Failed to connect to speech service. Retrying...", 5);
          fetchTokens(true).then(() => {
            if (speechTokenRef.current) {
              setTimeout(() => toggleRecording(), 1000);
            } else {
              notify("error", "Could not refresh token. Please try again later.", 5);
              setStartingConversation(false);
            }
          });
        } else {
          notify("error", "Speech recognition canceled due to an error.", 5);
        }
      };

      recognizerRef.current.startContinuousRecognitionAsync(() => {
        setIsRecognizing(true);
        setStartingConversation(false);

        setTimeout(() => {
          if (!didRecognize && isRecognizing) {
            notify("error", "No voice detected. Please try again.", 5);
            toggleRecording();
          }
        }, 10000);

        // setShowProcessingAnimation(true);
        // Initialize Audio Context and Analyser
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
          .then((stream) => {
            mediaStreamRef.current = stream;
            audioContextRef.current = new AudioContext();
            analyserRef.current = audioContextRef.current.createAnalyser();
            analyserRef.current.fftSize = 256;
            microphoneRef.current = audioContextRef.current.createMediaStreamSource(stream);
            scriptProcessorRef.current = audioContextRef.current.createScriptProcessor(256, 1, 1);
            analyserRef.current.connect(scriptProcessorRef.current);
            scriptProcessorRef.current.connect(audioContextRef.current.destination);
            microphoneRef.current.connect(analyserRef.current);
            dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);
            drawWaveform();
          })
          .catch((error) => {
            notify("Error", "Failed to access microphone. Please check your device settings.", 5);
          });
      },
        (error) => {
          console.error("Recognizer startup error:", error);
          notify("error", "Could not start recognition. Trying to refresh token...", 5);
          fetchTokens(true).then(() => {
            if (speechTokenRef.current) {
              setTimeout(() => toggleRecording(), 1000);
            } else {
              notify("error", "Failed to initialize speech recognition.", 5);
              setStartingConversation(false);
            }
          });
        });
    } else {
      // Stop recognition
      setStartingConversation(false);
      if (recognizerRef.current) {
        const textToCheck = transcriptionRef.current?.trim() || "";
        if (textToCheck.length < 150) {
          notify("warning", "Transcription is too short", 5, "Please include a few more patient details so we can provide better results.");
          return;
        }
        const endTime = Date.now();
        const elapsedTime = Math.floor((endTime - startTime) / 1000);
        
        // setVisitActive("post_visit");
        // setActiveTab(1);
        setPostvisitLoader(true);
        setEnablePostVisitLoader(true);

        setRecordTime(0);
        clearInterval(timerRef.current);

        const today = getDateString();
        setPrevisitRecordTimes((prev) => {
          const updated = { ...prev };
          updated[today] = [...(updated[today] || []), elapsedTime];
          return updated;
        });
        previsitRecordTimesRef.current = { ...previsitRecordTimesRef.current, [today]: [...(previsitRecordTimesRef.current[today] || []), elapsedTime] };


        if (isMobileDevice()) {
          notify('success', `You have successfully recorded ${Math.floor(elapsedTime / 60)} min ${elapsedTime % 60} sec.`, 5);
        }
        await stopRecording(false);
      }
    }
  };

  const stopRecording = async (generateNoteFromRecording = true) => {
    if (recognizerRef.current) {
      recognizerRef.current.stopContinuousRecognitionAsync(() => {
        if (mediaStreamRef.current) {
          mediaStreamRef.current.getTracks().forEach((track) => track.stop());
          mediaStreamRef.current = null;
        }

        // Close audio context
        if (audioContextRef.current) {
          audioContextRef.current.close();
          audioContextRef.current = null;
        }

        // Stop and remove analyser
        if (analyserRef.current) {
          analyserRef.current.disconnect();
          analyserRef.current = null;
        }

        // Stop animation
        if (microphoneRef.current) {
          microphoneRef.current.disconnect();
        }
        if (scriptProcessorRef.current) {
          scriptProcessorRef.current.disconnect();
        }

        setIsRecognizing(false);
      },
        (error) => console.error("Error stopping recognition:", error));
    }

    if (chechStartConversation) {
      let fullSentence = transcriptionRef.current?.trim();
      
      if (!fullSentence || (fullSentence === startingTranscriptionRef.current?.trim() && !enableClinicalNote)) {
        notify("error", "No new transcription available to save.", 5);
        setPostvisitLoader(false);
        setEnablePostVisitLoader(false);
        setActiveTab(0);
        return;
      }
      
      if(generateNoteFromRecording) {
        setDisabledNoteGenerate(true);
      }
      let allQuestions = transcriptQuestionsRef.current;
      let allDiagnoses = transcriptDiagnosisRef.current;
      // First save the transcription
      const saveResponse = await handleSaveTranscript(
        account_id,
        location_id,
        waiting_room_id,
        fullSentence,
        allQuestions,
        allDiagnoses
      );

      // Only proceed with post notes if transcription was saved successfully
      if (saveResponse && saveResponse.data && saveResponse.data.status === "success") {
        if(generateNoteFromRecording) {
          await getPostVisitFromDiagnosis(waiting_room_id);
        }
      } else {
        notify("error", "Failed to save transcription. Please try again.", 5);
        setPostvisitLoader(false);
        setEnablePostVisitLoader(false);
        setActiveTab(0);
        setDisabledNoteGenerate(false);
      }
    } else {
      notify("error", "No transcription available to save.", 5);
      setPostvisitLoader(false);
      setEnablePostVisitLoader(false);
      setActiveTab(0);
    }
  };

  const drawWaveform = () => {
    if (!canvasRef.current || !analyserRef.current) return;

    const canvas = canvasRef.current;
    const canvasCtx = canvas.getContext("2d");
    if (!canvasCtx) return;

    requestAnimationFrame(drawWaveform);
    analyserRef.current.getByteFrequencyData(dataArrayRef.current);

    canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
    const barCount = 20;
    const barWidth = (canvas.width / (2 * barCount)) * 0.8;
    const barGap = barWidth * 0.5;
    const centerY = canvas.height / 2;
    const centerX = canvas.width / 2;

    for (let i = 0; i < barCount; i++) {
      const index = Math.floor(i * (dataArrayRef.current.length / barCount));
      const barHeight = (dataArrayRef.current[index] / 256) * canvas.height;
      canvasCtx.fillStyle = '#00a106';
      canvasCtx.fillRect(centerX + i * (barWidth + barGap), centerY - barHeight / 2, barWidth, barHeight);
      canvasCtx.fillRect(centerX - (i + 1) * (barWidth + barGap), centerY - barHeight / 2, barWidth, barHeight);
    }
  };

  const getPostVisitFromDiagnosis = async (waitingId) => {
    setPostVisitLoaderId(waitingId);

    try {
      if (!userAccessToken()) return;
      const response = await fetch(
        `${Config.apiServerUrl}/waiting_room/post_visit_notes?account_id=${account_id}&location_id=${location_id}&waiting_room_id=${waitingId}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response?.json();
      if (data?.status === "success") {
        if (Object.keys(data)?.length > 0) {
          setPostVisitData(data?.post_visit_data || {});
          // setVisitActive("post_visit");
        }
      } else {
        // Check if the transcription text is long enough
        const textToCheck = transcriptionRef.current?.trim() || "";
        if (textToCheck.length > 150) {
          notify("error", "Server is currently busy", 5, "We're experiencing high traffic. Please try again in a moment.");
        } else {
          notify("error", "Text is too short", 5, "Please provide more detailed input to generate the clinical note.");
        }
        setActiveTab(0);
      }
    } catch (error) {
      console.error("Error retrieving post visit from diagnosis:", error);
    } finally {
      setPostvisitLoader(false);
      setEnablePostVisitLoader(false);
      setPostVisitLoaderId(null);
      setDisabledNoteGenerate(false);
    }
  };

  const handleTranscriptChange = (e) => {
    setChechStartConversation(true);
    setTranscription(e.target.value);
    transcriptionRef.current = e.target.value;
  };

  const handleSaveTranscript = async (
    accountId,
    locationId,
    id,
    text,
    transcriptAllQuestions,
    transcriptAllDiagnosis
  ) => {
    try {
      const response = await saveTranscriptionText(
        accountId,
        locationId,
        id,
        text,
        transcriptAllQuestions,
        transcriptAllDiagnosis,
        previsitRecordTimesRef.current
      );
      if (response) {
        if (!response?.detail && response?.data?.status === "success") {
          startingTranscriptionRef.current = response?.data?.refined_text || text;
          setTranscription(response?.data?.refined_text || text);
          // notify("success", "Transcription saved successfully", 5)
        }
      }
      return response;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        error?.response?.data?.detail
      ) {
        // notify("error", error?.response?.data?.detail, 5);
      }
      throw error;
    }
  };

  const closeViewModal = (open) => {
    // if (isRecognizing) {
    //   toggleRecording();
    // }
    if (isRecognizing && open === false) {
      notify("warning", "Stop recording before closing.", 5);
      return;
    }
    modalOpenRef.current = !!open;
    if (!open) {
      try { if (timerRef.current) { clearInterval(timerRef.current); } } catch {}
      autoCallCountRef.current = 0;
    }
    set_active_modal(open);
    window.scrollTo(0, previousScrollPosition);
  };

  const handleViewNote = () => {
    if (isMobileDevice()) {
      setViewNoteModal(true);
      setOpacityClass("docpro_opaciry_0");
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }
  }

  const saveNoteData = async (show_toast = true) => {
    const editData = noteRef.current?.getCleanedEditNoteData();
    if (editData) {
      const editNoteData = {
        account_id: account_id,
        location_id: location_id,
        id: waiting_room_id,
        post_visit_data: editData,
      };

      try {
        const response = await updatePostVisitNote(editNoteData);
        if (response) {
          if (response?.detail && show_toast) {
            notify("error", response?.detail, 5);
          }
          if (response?.data?.status === "success") {
            setPostVisitData(editData)
            if(show_toast) {
              notify("success", response?.data?.message, 5);
            }
          } else if (show_toast) {
            notify("error", response?.data?.message, 5);
          }
        }
      } catch (error) {
        if (error?.response && error?.response?.data && error?.response?.data?.detail && show_toast) {
          notify("error", error?.response?.data?.detail, 5);
        }
      } finally {
        setNoteEditMode(false);
        setHasChanges(false);
      }
    }
  }

  const uploadToEHR = async (force_upload=false) => {
    if(can_visit('ehr_veradigm')) {
      if(!!singlePatientData?.ehr_icd_note_id && pushEhrFlags?.icd_key && !force_upload) {
        setShowEHRPushWarning(true);
        return;
      }

      notify("info", "Posting your note to the EHR...", 5);
      setIsUploading(true);

      if(hasChanges) {
        await saveNoteData(false);
      }

      const uploadData = {
        account_id: account_id,
        location_id: location_id,
        waiting_room_id: waitingId,
        user_id: user_id,
        ehr_push_keys: pushEhrFlags
      };

      try {
        const response = await uploadChartToEHR(uploadData);
        if (response) {
          if (response?.detail) {
            notify("error", response.detail, 5);
          }
          if (response?.data?.status === "success") {
            notify("success", response?.data?.message, 5);
            setPostVisitUploadEmrId(waiting_room_id);
            setPushEhrResult(response?.data?.data || {});
          } else {
            notify("error", response.data.message, 5);
          }
        }
      } catch (error) {
        if (error?.response && error?.response?.data && error?.response?.data?.detail) {
          notify("error", error?.response?.data?.detail, 5);
        }
      } finally {
        setIsUploading(false);
        setPostVisitUploadEmrId(null);
      }
    } else {
      notify("error","You can't send data to EHR.");
    }
  };

  const handleGenerateNote = async () => {
    if (recognizerRef.current) {
      setStartingConversation(false);
      // setVisitActive("post_visit");

      const endTime = Date.now();
      const elapsedTime = Math.floor((endTime - startTime) / 1000);
      const textToCheck = transcriptionRef.current?.trim() || "";
      if (textToCheck.length < 150) {
        notify("warning", "Transcription is too short", 5, "Please include a few more patient details so we can provide better results.");
        return;
      }
      setRecordTime(0);
      clearInterval(timerRef.current);

      const today = getDateString();
      setPrevisitRecordTimes((prev) => {
        const updated = { ...prev };
        updated[today] = [...(updated[today] || []), elapsedTime];
        return updated;
      });
      previsitRecordTimesRef.current = { ...previsitRecordTimesRef.current, [today]: [...(previsitRecordTimesRef.current[today] || []), elapsedTime] };


    }
    setActiveTab(1);
    setPostvisitLoader(true);
    setEnablePostVisitLoader(true);

    await stopRecording();
  };

  const services = postVisitData?.potential_services_from_previsit_plans ||
    postVisitData?.potential_services_from_previsit_plan ||
    [];
  const allKeys = [...new Set(services.flatMap(item => Object.keys(item)))];

  const handlePushEhrCheckboxChange = (key, isChecked) => {
    setPushEhrFlags(prev => {
      const updated = { ...prev, [key]: isChecked };

      // If one of the linked keys is changed, update the other accordingly
      if (key === 'icd_key' || key === 'assessment_key') {
        updated.icd_key = isChecked;
        updated.assessment_key = isChecked;
      }

      return updated;
    });
  };

  return (
    <>
      <div style={{ height: "100%" }} ref={dropdownRef}>
        <Drawer.Root open={active_modal} onOpenChange={closeViewModal}>
          <Drawer.Trigger className="docpro_single_patiant_modal_btn"></Drawer.Trigger>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay" />
            <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
              <Drawer.Title className="sr-only">Patient Audit Report Details</Drawer.Title>
              <Drawer.Description className="sr-only">View details of an parient audit reports</Drawer.Description>
              <div className={`docpro_modal_wrap docpro_style_1 docpro_modal_xl ${opacityClass}`}>
                <div className="docpro_modal">
                  {isDataLoaded ? (
                    <>
                      {enableWarningView && (
                        <div className="docpro_text_alert docpro_orange_color text-center stickey_pevisit_note">
                          <Spacing lg={5} sm={5} />
                          <TriangleAlert width={20} height={20} className="warning-anim-color" />
                          <span className="docpro_fw_400">
                            {viewWarningText}
                          </span>
                          <Spacing lg={5} sm={5} />
                        </div>
                      )}
                      <div className="docpro_grid docpro_grid_col_2 docpro_previsit">
                        <div className="docpro_grid_item docpro_patient_body_left">
                          <div className="docpro_patient_head_2_border">
                            <div className="docpro_patient_head_2 patient_head_1_border">
                              <div>
                                <div className="docpro_media">
                                  <img
                                    src={
                                      signOutPatientData && signOutPatientData.sex === "M"
                                        ? maleAvatar
                                        : signOutPatientData && signOutPatientData.sex === "F"
                                          ? femaleAvatar
                                          : otherAvatar
                                    }
                                    alt="Avatar"
                                    width={40}
                                    height={40}
                                    style={{
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                  />
                                  <div className="docpro_media_right">
                                    <h2 className="docpro_fs_20 docpro_text_uppercase">
                                      {signOutPatientData && signOutPatientData.last_name && signOutPatientData.first_name
                                        ? `${signOutPatientData.last_name} ${signOutPatientData.first_name}`
                                        : ""
                                      }
                                    </h2>
                                    {signOutPatientData && signOutPatientData?.risk_level === "High" && (
                                      <span className="docpro_badge docpro_badge_red">
                                        High-Risk Patient
                                      </span>
                                    )}
                                    {signOutPatientData && signOutPatientData?.risk_level === "Moderate" && (
                                      <span className="docpro_badge docpro_badge_orange">
                                        Moderate-Risk Patient
                                      </span>
                                    )}
                                    {signOutPatientData && signOutPatientData?.risk_level === "Low" && (
                                      <span className="docpro_badge docpro_badge_green">
                                        Low-Risk Patient
                                      </span>
                                    )}
                                  </div>
                                </div>
                                {singlePatientData?.provider_username && (
                                  <p className="docpro_mb_0 mt-1"><b>Caregiver:</b> <span className="docpro_accent_color">{singlePatientData?.provider_username}</span></p>
                                )}
                              </div>
                              <div className="docpro_patient_head_buttons_wrap">
                                <div className="docpro_patient_head_buttons relative">
                                  <button
                                    className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn docpro_tip_checkbox${isRecognizing ? " docpro_recording_bg" : ""}${enableWarningView ? " docpro_recording_disabled_bg" : ""}`}
                                    type="button"
                                    onClick={ !enableWarningView ? toggleRecording : undefined }
                                    disabled={emptyPotentialAncillaryServices ? true : disabledCallBtn ? true : false }
                                  >
                                    {isRecognizing ? (
                                      <>
                                        <CircleStop /> End recording
                                      </>
                                    ) : (
                                      <>
                                        <CircleDot /> Start Conversation
                                        {enableWarningView && (
                                          <span className="docpro_tip">
                                            Only one user can interact with a patient's <br /> "Start Conversation" record at a time.<br /> Please try again after the other <br /> user has closed this patient view.
                                          </span>
                                        )}
                                        {disabledCallBtn && (
                                          <span className="docpro_loading">
                                            <Loader width={20} height={20} />
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </button>
                                  <div className={`docpro_patient_head_buttons_in${isRecognizing ? " set_height" : ""}`}>
                                    <div className={`docpro_record_timer ${isRecognizing ? "block" : "none"}`}>
                                      <canvas
                                        ref={canvasRef}
                                        width={112}
                                        height={32}
                                      ></canvas>
                                      <span style={{ width: '65px' }}>
                                        {formatRecordingTime(recordTime)}
                                      </span>
                                    </div>
                                    {!isRecognizing && (
                                      <>
                                        {can_visit("_call_note") && (
                                          <div className="dropdown-container relative small_screen_display_hide">
                                            <button
                                              type="button"
                                              className="docpro_bordered_btn docpro_fw_600 docpro_sp_btn_1 w-full"
                                              onClick={() => {
                                                setViewStatusOptions(!viewStatusOptions);
                                              }}
                                              disabled={
                                                enableWarningView ? true : false
                                              }
                                            >
                                              <Phone width={16} height={16} />
                                              <span>Call</span>
                                            </button>
                                            {viewStatusOptions && (
                                              <div className="docpro_button_toggle_options call_note_dropdown">
                                                <p>Reason for call</p>
                                                {filteredConditions && filteredConditions.length > 0 && (
                                                  <button
                                                    type="button"
                                                    onClick={() => {
                                                      handleCall("ccm");
                                                    }}
                                                  >
                                                    <Stethoscope width={15} height={15} className="mr-2" />
                                                    <span>CCM</span>
                                                  </button>
                                                )}
                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    handleCall("scheduling")
                                                  }
                                                >
                                                  <Calendar width={15} height={15} className="mr-2" />
                                                  <span>Schedule</span>
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        <button
                                          className="docpro_bordered_btn docpro_fw_600 docpro_sp_btn_1 w-full small_screen_display_hide"
                                          type="button"
                                          onClick={() =>
                                            handleSignOutSheet(
                                              signOutPatientData?.id,
                                              waitingId,
                                              exchangeDate(previsitDos?.dos)
                                            )
                                          }
                                        >
                                          <Printer width={16} height={16} />
                                          <span>Print</span>
                                        </button>
                                      </>
                                    )}
                                  </div>
                                  {isMobileDevice() && (
                                    <button
                                      className={`docpro_bordered_btn docpro_fw_600 docpro_view_note_btn docpro_tip_checkbox`}
                                      type="button"
                                      onClick={handleViewNote}
                                    >
                                      <FileText /> View Note
                                    </button>
                                  )}
                                  {startingConversation && (
                                    <div className="docpro_call_starting">
                                      <span>Starting...</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="docpro_patient_head_2 patient_head_2_border">
                              <div className="docpro_patient_head_info_list">
                                <ul>
                                  <li>
                                    <b>Gender: </b>
                                    {signOutPatientData && signOutPatientData.sex
                                      ? Gender(signOutPatientData.sex) : ""
                                    }
                                  </li>
                                  <li>
                                    <b>Insurance: </b>
                                    {signOutPatientData
                                      ? signOutPatientData.insurance
                                        ? signOutPatientData.insurance.name
                                        : ""
                                      : ""
                                    }
                                  </li>
                                  <li>
                                    <b>DOB: </b>
                                    {signOutPatientData && signOutPatientData.dob
                                      ? `${exchangeDate(signOutPatientData.dob)} 
                                      (${calculateAgeFromDOB(signOutPatientData.dob)} years old)`
                                      : ""
                                    }
                                  </li>
                                  {/* <li>
                                    <b>Insurance Status: </b>Acitve
                                  </li> */}
                                </ul>
                                <ul className="small_screen_display_hide">
                                  <li>
                                    <b>DOS: </b>
                                    {previsitDos}
                                  </li>
                                  <li>
                                    <b>Last annual wellness visit: </b>
                                    {lastWellnessDate ? lastWellnessDate : ""}
                                  </li>
                                  <li>
                                    <b>Last hospitalization date: </b>
                                    {signOutPatientData && signOutPatientData?.last_hospitalization_date
                                      ? signOutPatientData?.last_hospitalization_date
                                      : ""
                                    }
                                  </li>
                                  {/* <li>
                                    <b>RAF score: </b>
                                  </li> */}
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div className="small_screen_display_show">
                            <Spacing lg="20" />
                            <p className="docpro_fs_16 docpro_fw_400" style={{ color: "#747474" }}>
                              <Clock9 width={16} height={16} /> You recorded for{" "}
                              {previsitRecordTimes ? (() => {
                                const totalSeconds = Object.values(previsitRecordTimes).flat().reduce((sum, time) => sum + time, 0);
                                const minutes = Math.floor(totalSeconds / 60);
                                const seconds = totalSeconds % 60;
                                return `${minutes} min ${seconds} sec`;
                              })()
                                : "0 min 0 sec"}
                            </p>
                            {previsitRecordTimes && Object.entries(previsitRecordTimes).map(
                              ([date, times], index) => (
                                <div key={index}>
                                  <p className="docpro_fs_13 docpro_fw_400" style={{ color: "#747474" }}>
                                    <b className="mb-1"
                                      style={{
                                        display: "inline-flex",
                                        color: "#747474",
                                      }}
                                    >
                                      {exchangeDate(date)}
                                    </b><br />
                                    {times.map((time, idx) => (
                                      <span
                                        key={idx}
                                        style={{
                                          display: "block",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        <b style={{ color: "#747474" }}>
                                          Session {idx + 1}:{" "}
                                        </b>
                                        {Math.floor(time / 60)} min{" "}
                                        {time % 60} sec
                                        <br />
                                      </span>
                                    ))}
                                  </p>
                                </div>
                              )
                            )}
                          </div>

                          <div className="docpro_patient_body_2 small_screen_display_hide">
                            <div className={`docpro_patient_body_2_left${visitActive === "post_visit" ? " post_visit_active" : "" }`}>
                              <div className="docpro_tab_wrap">
                                <div className="docpro_tab">
                                  <button
                                    type="button"
                                    className={`docpro_tab_item ${visitActive === "pre_visit" ? "active" : ""} ${can_visit('ehr_veradigm') && "docpro_set_active_tab_width"}`}
                                    onClick={() => setVisitActive("pre_visit")}
                                    style={{ justifyContent: can_visit('ehr_veradigm') ? "start" : "center" }}
                                  >
                                    Pre-visit
                                  </button>
                                  {!can_visit('ehr_veradigm') && (
                                    <button
                                      type="button"
                                      className={`docpro_tab_item ${visitActive === "during_visit" ? "active" : ""}`}
                                      onClick={() => {
                                        setVisitActive("during_visit");
                                        setActiveTab(0);
                                      }}
                                      style={{
                                        justifyContent: "center",
                                        cursor: emptyDuringVisit || emptyPotentialAncillaryServices ? "auto" : "pointer",
                                      }}
                                      disabled={emptyDuringVisit || emptyPotentialAncillaryServices ? true : false}
                                    >
                                      {(emptyDuringVisit || emptyPotentialAncillaryServices) && (
                                        <Lock height={15} width={15} />
                                      )}
                                      During visit
                                    </button>
                                  )}
                                  {/* <button
                                    type="button"
                                    className={`docpro_tab_item ${
                                      visitActive === "post_visit" ? "active" : ""
                                    }`}
                                    onClick={() => {
                                      setVisitActive("post_visit");
                                      setActiveTab(1);
                                    }}
                                    style={{
                                      justifyContent: "center",
                                      cursor: emptyPotentialAncillaryServices ? "auto" : "pointer",
                                    }}
                                    disabled={emptyPotentialAncillaryServices ? true : false}
                                  >
                                    {(emptyPotentialAncillaryServices) && (
                                      <Lock height={15} width={15} />
                                    )}
                                    Post visit
                                  </button> */}
                                </div>
                                <hr />
                              </div>

                              {visitActive === "pre_visit" && (
                                <div className="docpro_modal_card_1_wrap_overflow custom-scroll">
                                  {signOutPatientData?.care_gaps && signOutPatientData?.care_gaps.length > 0 && (
                                    <div className="docpro_modal_card_1">
                                      <div className="docpro_modal_card_1_head">
                                        <Ruler width={20} height={20} />
                                        <span className="docpro_fw_700">
                                          Pending QM
                                        </span>
                                      </div>
                                      <div className="docpro_modal_card_1_body">
                                        <div className="docpro_modal_bages">
                                          {signOutPatientData?.care_gaps?.map(
                                            (item, index) => item.status === "pending" && (
                                              <span key={index}>
                                                {item.name}
                                              </span>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {filteredConditions && filteredConditions.length > 0 && (
                                    <div className="docpro_modal_card_1">
                                      <div className="docpro_modal_card_1_head">
                                        <SquareActivity width={20} height={20} />
                                        <span className="docpro_fw_700">
                                          Chronic conditions
                                        </span>
                                      </div>
                                      <div className="docpro_modal_card_1_body">
                                        <div className="docpro_modal_bages">
                                          {filteredConditions.map((item) => (
                                            <span
                                              key={item.id}
                                              className="docpro_badge docpro_badge_dynamic"
                                              title={item.name}
                                            >
                                              {item.name}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* {specialityProfiles?.length > 0 && (
                                    <div className="docpro_modal_card_1">
                                      <div className="docpro_modal_card_1_head">
                                        <ShieldPlus width={20} height={20} />
                                        <span className="docpro_fw_700">
                                          Specialty
                                        </span>
                                      </div>
                                      <div className="docpro_modal_card_1_body">
                                        <div className="docpro_modal_card_badges">
                                          {[
                                            ...new Set(specialityProfiles),
                                          ]?.map((speciality, index) => (
                                            <span
                                              key={index}
                                              className="docpro_badge docpro_badge_dynamic"
                                              title={speciality?.name}
                                            >
                                              {speciality?.name}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                                  {Object.keys(lastThreeVisitData).length > 0 && (
                                    <div className="docpro_modal_card_1">
                                      <div className="docpro_modal_card_1_head">
                                        <FileText width={20} height={20} />
                                        <span className="docpro_fw_700">
                                          Last 3 visits summary
                                        </span>
                                      </div>
                                      <div className="docpro_modal_card_1_body">
                                        <table className="docpro_mb_0 docpro_modal_card_1_table_1">
                                          <tbody>
                                            {Object.entries(lastThreeVisitData).map(([date, summary], index) => {
                                              return (
                                                <tr key={index}>
                                                  <td>
                                                    {exchangeDate(date)}
                                                  </td>
                                                  <td>
                                                    <span style={{ whiteSpace: "wrap" }}>
                                                      {summary}
                                                    </span>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                  {emptyPotentialAncillaryServices && (
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "60px",
                                        justifyContent: "center",
                                        display: "grid",
                                        alignContent: "center",
                                      }}
                                    >
                                      <span className="audit_report_loader"></span>
                                    </div>
                                  )}
                                  {[
                                    "Screening_Codes",
                                    "EM_Codes",
                                    "Counseling_Codes",
                                    "Procedure_Codes",
                                    "HCC_Codes",
                                    "For_Televisit",
                                    "For_Post-Hospital"
                                  ]?.filter(
                                    (codeType) => ancillaryServices?.[codeType]?.length > 0
                                  )?.map((codeType, index) => (
                                    <React.Fragment key={index}>
                                      <div className="docpro_modal_card_1">
                                        <div className="docpro_modal_card_1_head">
                                          {codeType === "HCC_Codes" ? (
                                            <Hospital width={20} height={20} />
                                          ) : codeType === "For_Televisit" ? (
                                            <Phone width={20} height={20} />
                                          ) : codeType === "For_Post-Hospital" ? (
                                            <Hospital width={20} height={20} />
                                          ) : (
                                            <BriefcaseMedical width={20} height={20} />
                                          )}
                                          <span className="docpro_fw_700">
                                            {codeType.replace("_", " ")}
                                          </span>
                                        </div>
                                        <div className="docpro_modal_card_1_body">
                                          <div className="docpro_modal_card_1_table_2_wrap">
                                            <div className="docpro_table_responsive">
                                              <table
                                                className="docpro_mb_0 docpro_primary_color docpro_modal_card_1_table_2"
                                                style={{ minWidth: "350px" }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th>Service</th>
                                                    <th style={{ width: "90px" }}>Codes</th>
                                                    <th style={{ width: "135px" }}>Last used date</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {ancillaryServices[codeType].map((item, index) => (
                                                    <React.Fragment key={index}>
                                                      <tr>
                                                        <td>{item?.service_name || ""}</td>
                                                        <td>
                                                          {codeType === "Screening_Codes"
                                                            ? item.screening_code
                                                            : codeType === "EM_Codes"
                                                              ? item.em_code
                                                              : codeType === "Counseling_Codes"
                                                                ? item.counseling_code
                                                                : codeType === "Procedure_Codes"
                                                                  ? item.procedure_code
                                                                  : codeType === "HCC_Codes"
                                                                    ? item.hcc_code
                                                                    : codeType === "For_Televisit"
                                                                      ? item.telehealth_code
                                                                      : codeType === "For_Post-Hospital"
                                                                        ? item.post_hospital_code
                                                                        : ""}
                                                        </td>
                                                        <td>{item?.dos ? exchangeDate(item.dos) : ""}</td>
                                                      </tr>

                                                      {(codeType === "Screening_Codes" ||
                                                        codeType === "Procedure_Codes" ||
                                                        codeType === "Counseling_Codes") &&
                                                        item?.service_name_icd && (
                                                          <tr>
                                                            <td>{item.service_name_icd}</td>
                                                            <td>{item.relevant_icd_code || ""}</td>
                                                            <td></td> {/* Keep 3rd column blank to match columns */}
                                                          </tr>
                                                        )}
                                                    </React.Fragment>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                              {visitActive === "during_visit" && (
                                <div className="docpro_modal_card_1_wrap_overflow custom-scroll">
                                  <div className="docpro_modal_card_1">
                                    <div className="docpro_modal_card_1_head question_diagonosis">
                                      <div className="flex items-center docpro_grid_gap_10">
                                        <MessageCircleQuestion width={20} height={20} />
                                        <span className="docpro_fw_700">
                                          Questions
                                        </span>
                                      </div>
                                      {/* {showProcessingAnimation && (
                                        <div className={`circle-loader ${checkProcessingAnimation}`} >
                                          <div className="checkmark draw"
                                            style={{
                                              display: checkProcessingAnimation ? "block" : "none",
                                            }}
                                          ></div>
                                        </div>
                                      )} */}
                                    </div>
                                    <div className="docpro_modal_card_1_body">
                                      <div className="docpro_questions" id="question_list" >
                                        {transcriptQuestions?.length > 0 ? (
                                          [
                                            ...new Set(transcriptQuestions),
                                          ]?.map((question, index) => (
                                            <div key={index} className="docpro_question" >
                                              {question}
                                            </div>
                                          ))
                                        ) : (
                                          <span className="docpro_ternary_color">
                                            No questions available
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="docpro_modal_card_1">
                                    <div className="docpro_modal_card_1_head question_diagonosis">
                                      <div className="flex items-center docpro_grid_gap_10">
                                        <Hospital width={20} height={20} />
                                        <span className="docpro_fw_700">
                                          Diagonosis
                                        </span>
                                      </div>
                                      {showProcessingAnimation && (
                                        <div className={`circle-loader ${checkProcessingAnimation}`} >
                                          <div className="checkmark draw"
                                            style={{
                                              display: checkProcessingAnimation ? "block" : "none",
                                            }}
                                          ></div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="docpro_modal_card_1_body">
                                      <div className="docpro_modal_bages" id="diagonosis_list" >
                                        {transcriptDiagnosis?.length > 0 ? (
                                          [
                                            ...new Set(transcriptDiagnosis),
                                          ]?.map((diagnosis, index) => (
                                            <span key={index}>{diagnosis}</span>
                                          ))
                                        ) : (
                                          <div className="docpro_ternary_color">
                                            No diagnosis available
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div> */}

                                  {[
                                    "Screening_Codes",
                                    "Counseling_Codes",
                                    "Procedure_Codes",
                                    "HCC_Codes",
                                    "For_Televisit",
                                    "For_Post-Hospital"
                                  ].filter(
                                    (codeType) => ancillaryServices?.[codeType]?.length > 0
                                  )?.map((codeType, index) => (
                                    <React.Fragment key={index}>
                                      <div className="docpro_modal_card_1">
                                        <div className="docpro_modal_card_1_head">
                                          {codeType === "HCC_Codes" ? (
                                            <Hospital width={20} height={20} />
                                          ) : codeType === "For_Televisit" ? (
                                            <Phone width={20} height={20} />
                                          ) : codeType === "For_Post-Hospital" ? (
                                            <Hospital width={20} height={20} />
                                          ) : (
                                            <BriefcaseMedical width={20} height={20} />
                                          )}
                                          <span className="docpro_fw_700">
                                            {codeType.replace("_", " ")}
                                          </span>
                                        </div>
                                        <div className="docpro_modal_card_1_body">
                                          <div className="docpro_modal_card_1_table_2_wrap">
                                            <div className="docpro_table_responsive">
                                              <table
                                                className="docpro_mb_0 docpro_primary_color docpro_modal_card_1_table_2"
                                                style={{ minWidth: "350px" }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th>Service</th>
                                                    <th style={{ width: "90px" }}>Codes</th>
                                                    <th style={{ width: "135px" }}>Last used date</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {ancillaryServices[codeType]?.map((item, index) => {
                                                    return (
                                                      <tr key={index}>
                                                        <td>
                                                          {item?.service_name || ""}
                                                        </td>
                                                        <td>
                                                          {codeType === "Screening_Codes"
                                                            ? item.screening_code
                                                            : codeType === "EM_Codes"
                                                              ? item.em_code
                                                              : codeType === "Counseling_Codes"
                                                                ? item.counseling_code
                                                                : codeType === "Procedure_Codes"
                                                                  ? item.procedure_code
                                                                  : codeType === "For_Televisit"
                                                                    ? item.telehealth_code
                                                                    : codeType === "For_Post-Hospital"
                                                                      ? item.post_hospital_code
                                                                      : ""}
                                                        </td>
                                                        <td>
                                                          {item?.dos
                                                            ? exchangeDate(item.dos)
                                                            : ""}
                                                        </td>
                                                      </tr>
                                                    );
                                                  })}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                              {visitActive === "post_visit" && (
                                <div className="docpro_modal_card_1_wrap_overflow custom-scroll">
                                  {postvisitLoader ? (
                                    <>
                                      <div
                                        className="skeleton-tab"
                                        style={{ marginTop: "20px" }}
                                      ></div>
                                      <div
                                        className="skeleton-tab"
                                        style={{ marginTop: "15px" }}
                                      ></div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="docpro_modal_card_1 clinical_post_visit_copy">
                                        <div className="docpro_modal_card_1_head">
                                          <Stethoscope width={20} height={20} />
                                          <span className="docpro_fw_700">
                                            Clinical suggestions
                                          </span>
                                          <button
                                            className="docpro_modal_card_1_head_btn"
                                            onClick={() =>
                                              copyToHtmlClipboard(
                                                "clinical_post_visit_copy"
                                              )
                                            }
                                          >
                                            <Copy height={16} width={16} />
                                          </button>
                                        </div>
                                        <div className="docpro_modal_card_1_body">
                                          <div className="docpro_modal_card_1_content">
                                            {postVisitData && Object.keys(postVisitData).length > 0 &&
                                              postVisitData.reason_for_visit?.some((r) =>
                                                Array.isArray(r.icd_codes) && r.icd_codes.length > 0
                                              ) ? (
                                              <>
                                                {postVisitData.reason_for_visit
                                                  .flatMap((r) =>
                                                    r.icd_codes || []
                                                  )
                                                  .map((code, i) => (
                                                    <p key={i}>
                                                      {code.description} (ICD-10: {code.code})
                                                    </p>
                                                  ))
                                                }
                                              </>
                                            ) : (
                                              <div className="docpro_ternary_color">
                                                No clinical suggestions available
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="docpro_modal_card_1 diagnosis_post_visit_copy">
                                        <div className="docpro_modal_card_1_head">
                                          <ClipboardList
                                            width={20}
                                            height={20}
                                          />
                                          <span className="docpro_fw_700">
                                            Diagnosis suggestions
                                          </span>
                                          <button
                                            className="docpro_modal_card_1_head_btn"
                                            onClick={() =>
                                              copyToHtmlClipboard(
                                                "diagnosis_post_visit_copy"
                                              )
                                            }
                                          >
                                            <Copy height={16} width={16} />
                                          </button>
                                        </div>
                                        <div className="docpro_modal_card_1_body">
                                          <div className="docpro_modal_card_1_content">
                                            {/* {Object.keys(postVisitData?.diagnosis_suggestions)?.length > 0 ? (
                                              <div>
                                                <b>Treatment plan suggestion</b>
                                                <ul>
                                                  {postVisitData?.diagnosis_suggestions?.treatment_suggestions?.length > 0 ? (
                                                    [...new Set(postVisitData?.diagnosis_suggestions?.treatment_suggestions)]?.map(
                                                      (treatmentSuggestions, index) => (
                                                        <li key={index}>
                                                          {treatmentSuggestions}
                                                        </li>
                                                      )
                                                    )
                                                  )
                                                  :
                                                    <li className="docpro_ternary_color">
                                                      No treatment plan suggestion available
                                                    </li>
                                                  }
                                                </ul>
                                                <Spacing lg="10" sm="10"/>
                                                <b>Follow-up suggestion</b>
                                                <ul>
                                                  {postVisitData?.diagnosis_suggestions?.follow_up_suggestions?.length > 0 ? (
                                                    [...new Set(postVisitData?.diagnosis_suggestions?.follow_up_suggestions)]?.map(
                                                      (followSuggestions, index) => (
                                                        <li key={index}>
                                                          {followSuggestions}
                                                        </li>
                                                      )
                                                    )
                                                  )
                                                  :
                                                    <li className="docpro_ternary_color">
                                                      No follow-up suggestion available
                                                    </li>
                                                  }
                                                </ul>
                                                <Spacing lg="10" sm="10"/>
                                                <b>Test suggestions</b>
                                                <ul>
                                                  {postVisitData?.diagnosis_suggestions?.test_suggestions?.length > 0 ? (
                                                    [...new Set(postVisitData?.diagnosis_suggestions?.test_suggestions)]?.map(
                                                      (testSuggestions, index) => (
                                                        <li key={index}>
                                                          <b>{testSuggestions?.name} (CPT: {testSuggestions?.cpt_code})</b>
                                                          <br />
                                                          {testSuggestions?.suggestion}
                                                        </li>
                                                      )
                                                    )
                                                  )
                                                  :
                                                    <li className="docpro_ternary_color">
                                                      No test suggestions available
                                                    </li>
                                                  }
                                                </ul>
                                              </div>
                                            ) : (
                                              <div className="docpro_ternary_color">
                                                No diagnosis suggestions available
                                              </div>
                                            )} */}
                                            {postVisitData && Object.keys(postVisitData).length > 0 ? (
                                              <>
                                                {/* TREATMENT SUGGESTIONS */}
                                                <div>
                                                  <p className="chart_inline_copy">
                                                    <b>Treatment Suggestions:</b>
                                                    <span className="pointer"
                                                      onClick={() =>
                                                        copyToHtmlClipboard("treatment_suggestion_copy")
                                                      }
                                                    >
                                                      <Copy height={14} width={14} />
                                                    </span>
                                                  </p>
                                                  {postVisitData.reason_for_visit?.some((r) =>
                                                    Array.isArray(r.diagnosis_suggestions?.treatment_suggestions) &&
                                                    r.diagnosis_suggestions.treatment_suggestions.length > 0
                                                  ) ? (
                                                    <ul className="treatment_suggestion_copy">
                                                      {postVisitData.reason_for_visit.flatMap(
                                                        (r) => r.diagnosis_suggestions?.treatment_suggestions || []
                                                      )
                                                        .map((s, i) => (
                                                          <li key={i}>{s}</li>
                                                        ))}
                                                    </ul>
                                                  ) : (
                                                    <p className="docpro_ternary_color">
                                                      <i>None</i>
                                                    </p>
                                                  )}
                                                </div>
                                                <br />

                                                {/* FOLLOW-UP SUGGESTIONS */}
                                                <div>
                                                  <p className="chart_inline_copy">
                                                    <b>Follow-up Suggestions:</b>
                                                    <span className="pointer"
                                                      onClick={() =>
                                                        copyToHtmlClipboard("follow_up_suggestions_copy")
                                                      }
                                                    >
                                                      <Copy height={14} width={14} />
                                                    </span>
                                                  </p>
                                                  {postVisitData.reason_for_visit?.some((r) =>
                                                    Array.isArray(r.diagnosis_suggestions?.follow_up_suggestions) &&
                                                    r.diagnosis_suggestions.follow_up_suggestions.length > 0
                                                  ) ? (
                                                    <ul className="follow_up_suggestions_copy">
                                                      {postVisitData.reason_for_visit.flatMap(
                                                        (r) => r.diagnosis_suggestions?.follow_up_suggestions || []
                                                      )
                                                        .map((s, i) => (
                                                          <li key={i}>{s}</li>
                                                        ))}
                                                    </ul>
                                                  ) : (
                                                    <p className="docpro_ternary_color">
                                                      <i>None</i>
                                                    </p>
                                                  )}
                                                </div>
                                                <br />

                                                {/* TEST SUGGESTIONS */}
                                                <div>
                                                  <p className="chart_inline_copy">
                                                    <b>Test Suggestions:</b>
                                                    <span className="pointer"
                                                      onClick={() =>
                                                        copyToHtmlClipboard("test_suggestions_copy")
                                                      }
                                                    >
                                                      <Copy height={14} width={14} />
                                                    </span>
                                                  </p>
                                                  {postVisitData.reason_for_visit?.some((r) =>
                                                    Array.isArray(r.diagnosis_suggestions?.test_suggestions) &&
                                                    r.diagnosis_suggestions.test_suggestions.length > 0
                                                  ) ? (
                                                    <ul className="test_suggestions_copy">
                                                      {postVisitData.reason_for_visit.flatMap(
                                                        (r) => r.diagnosis_suggestions?.test_suggestions || []
                                                      )
                                                        .map((t, i) => (
                                                          <li key={i}>
                                                            {t.name} ({t.cpt_code}):{" "}{t.suggestion}
                                                          </li>
                                                        ))}
                                                    </ul>
                                                  ) : (
                                                    <p className="docpro_ternary_color">
                                                      <i>None</i>
                                                    </p>
                                                  )}
                                                </div>
                                              </>
                                            ) : (
                                              <p>No data available</p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="docpro_grid_item">
                          <div className="docpro_patient_body_2 small_screen_display_hide">
                            <div className="docpro_patient_body_2_right">
                              <div className="docpro_modal_card_2">
                                <div className="docpro_tab_wrap" style={{ borderBottom: "1px solid #ddd" }}>
                                  <div className="docpro_tab">
                                    <button
                                      type="button"
                                      className={`docpro_tab_item audit_report ${activeTab === 0 ? "active" : ""}`}
                                      onClick={() => {
                                        setActiveTab(0);
                                        if (!can_visit('ehr_veradigm')) {
                                          setVisitActive("during_visit");
                                        }
                                      }}
                                    >
                                      <Speech width={17} height={17} color="#7e808a" />
                                      Doctor's input
                                    </button>
                                    <button
                                      type="button"
                                      className={`docpro_tab_item audit_report ${activeTab === 1 ? "active" : ""}`}
                                      onClick={() => {
                                        setActiveTab(1);
                                        // setVisitActive("post_visit");
                                      }}
                                    >
                                      <FileText width={16} height={16} color="#7e808a" />
                                      Note
                                    </button>
                                    {/* <button
                                      type="button"
                                      className={`docpro_tab_item audit_report ${
                                        activeTab === 2 ? 'active' : ''
                                      }`}
                                      onClick={() => setActiveTab(2)}
                                    >
                                      Codes
                                    </button>
                                    <button
                                      type="button"
                                      className={`docpro_tab_item audit_report ${
                                        activeTab === 3 ? 'active' : ''
                                      }`}
                                      onClick={() => setActiveTab(3)}
                                    >
                                      Chat
                                    </button>
                                    <button
                                      type="button"
                                      className={`docpro_tab_item audit_report ${
                                        activeTab === 4 ? 'active' : ''
                                      }`}
                                      onClick={() => setActiveTab(4)}
                                    >
                                      Outreach
                                    </button> */}
                                  </div>
                                  <hr />
                                </div>
                                {activeTab === 0 && (
                                  <div className="docpro_tab_modal_right">
                                    <div
                                      className="docpro_tab_modal_right_in relative"
                                      style={{ overflow: "hidden" }}
                                    >
                                      <textarea
                                        rows={20}
                                        cols={28}
                                        minLength={10}
                                        id="transcription_output"
                                        value={transcription}
                                        onChange={handleTranscriptChange}
                                        placeholder="Write what happened in the visit — symptoms, medications, exam findings, and next steps..."
                                        style={{
                                          width: "100%",
                                          height: "calc(100% - 50px)",
                                          padding: "8px",
                                          outline: "none",
                                          resize: "none",
                                          borderRadius: "8px",
                                        }}
                                      />
                                      <button type="button"
                                        disabled={disabledNoteGenerate || enableWarningView}
                                        onClick={() => {handleGenerateNote();}}
                                        className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_upload_gradient_btn docpro_mt_auto"
                                      >
                                        <WandSparkles width={20} height={20} />
                                        <span>Generate clinical note</span>
                                        {disabledNoteGenerate && (
                                          <span className="docpro_loading">
                                            <Loader width={20} height={20} />
                                          </span>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                )}
                                {activeTab === 1 && (
                                  <div
                                    className="docpro_tab_modal_right"
                                    style={{ padding: "0 0 10px 0" }}
                                  >
                                    <div className="docpro_tab_modal_right_in docpro_custom_note_section">
                                      {postvisitLoader ? (
                                        <div className="py-2 px-3">
                                          <div className="flex items-center justify-between mb-2">
                                            <Skeleton width="8rem" height="2.5rem" borderRadius="8px"></Skeleton>
                                            <Skeleton width="8rem" height="2.5rem" borderRadius="8px"></Skeleton>
                                            <Skeleton width="8rem" height="2.5rem" borderRadius="8px"></Skeleton>
                                          </div>
                                          <p className="mb-1"><b>REASON FOR VISIT:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                          <p className="mb-1"><b>HISTORY OF PRESENT ILLNESS:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                          <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                          <p className="mb-1"><b>REVIEW OF SYSTEMS:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                          <Skeleton width="80%" borderRadius="8px" className="mb-2"></Skeleton>
                                          <Skeleton width="60%" borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                          <p className="mb-1"><b>PHYSICAL EXAM:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                          <p className="mb-1"><b>DIAGNOSIS CODE:</b></p>
                                          <Skeleton width="50%" borderRadius="8px" className="mb-2" count={3}></Skeleton>
                                          <p className="mb-1"><b>ASSESSMENT/PLAN:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2" count={3}></Skeleton>
                                          <p className="mb-1"><b>CPT CODES:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                          <Skeleton width="60%" borderRadius="8px" className="mb-2"></Skeleton>
                                          <p className="mb-1"><b>SUGGESTED SERVICES FROM PRE VISIT:</b></p>
                                          <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                          <Skeleton width="60%" borderRadius="8px" className="mb-2"></Skeleton>
                                          <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                          <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                        </div>
                                      ) : (
                                        <>
                                          {postVisitData && Object?.keys(postVisitData)?.length > 0 && (
                                            <div className="docpro_border_btns_wrap note_div">
                                              {!noteEditMode ? (
                                                <button
                                                  className="docpro_border_btn copy_all_btn"
                                                  style={{ cursor: isUploading ? 'auto' : 'pointer' }}
                                                  onClick={() => { setNoteEditMode(true); }}
                                                  disabled={isUploading || enableWarningView}
                                                >
                                                  <Pencil width={15} height={15} />
                                                  <span>Edit</span>
                                                </button>
                                              ) : (
                                                <>
                                                  {hasChanges && (
                                                    <button
                                                      className="docpro_border_btn docpro_filed_btn copy_all_btn"
                                                      onClick={saveNoteData}
                                                    >
                                                      <Save width={15} height={15} />
                                                      <span>Save</span>
                                                    </button>
                                                  )}
                                                  <button
                                                    className="docpro_border_btn copy_all_btn"
                                                    onClick={() => { setNoteEditMode(false); setHasChanges(false); }}
                                                  >
                                                    <X width={15} height={15} />
                                                    <span>Cancel</span>
                                                  </button>
                                                </>
                                              )}
                                              <button
                                                className="docpro_border_btn copy_all_btn"
                                                onClick={() =>
                                                  copyToHtmlClipboard("subjective_note_copy")
                                                }
                                              >
                                                <Copy width={15} height={15} />
                                                <span>Copy all</span>
                                              </button>
                                              {can_visit('ehr_veradigm') && (
                                                <button
                                                  className="docpro_upload_gradient_btn"
                                                  onClick={() => {uploadToEHR(false);}}
                                                  disabled={isUploading}
                                                >
                                                  <Upload width={15} height={15} />
                                                  <span>Send to EHR</span>
                                                  {isUploading && (
                                                    <span className="docpro_loading">
                                                      <Loader width={20} height={20} />
                                                    </span>
                                                  )}
                                                </button>
                                              )}
                                            </div>
                                          )}

                                          <div className="docpro_modal_card_1 no_style docpro_all_notes custom-scroll">
                                            {singlePatientData?.ehr_sent_data_time && (
                                              <p 
                                                className="docpro_mb_0 text-center" 
                                                style={{ background: '#bcb5b370', color: '#636363', fontWeight: 400, paddingBottom: '1px' }}
                                                onClick={(e) => {
                                                  if ((e.detail === 3) && singlePatientData?.t_model) {
                                                    notify("info", singlePatientData?.t_model, 2);
                                                  }
                                                }}
                                              >
                                                Sent to EHR on {singlePatientData?.ehr_sent_data_time}
                                              </p>
                                            )}
                                            <div className="docpro_modal_card_1_body">
                                              <div className="docpro_modal_card_1_content subjective_note_copy">
                                                {postVisitData && Object?.keys(postVisitData)?.length > 0 ? (
                                                  noteEditMode ? (
                                                    <AuditReporteditNote
                                                      ref={noteRef}
                                                      initialData={postVisitData}
                                                      noteEditMode={noteEditMode}
                                                      setHasChanges={setHasChanges}
                                                    />
                                                  ) : (
                                                    <>
                                                      {/* REASON FOR VISIT */}
                                                      {!can_visit('ehr_veradigm') && (
                                                        <>
                                                          <div>
                                                            <p className="chart_inline_copy">
                                                              <b>
                                                                REASON FOR VISIT:
                                                              </b>
                                                              <span className="pointer" onClick={() => copyToHtmlClipboard("reason_for_visit_copy")}>
                                                                <Copy height={14} width={14} />
                                                              </span>
                                                            </p>
                                                            {Array.isArray(postVisitData?.reason_for_visit) &&
                                                              postVisitData?.reason_for_visit?.length > 0 &&
                                                              postVisitData?.reason_for_visit?.every(item => typeof item === "string") ? (
                                                              <ul className="reason_for_visit_copy">
                                                                {postVisitData?.reason_for_visit.map((r, i) => (
                                                                  <li key={i} className="docpro_capitalize">
                                                                    {r?.replace(/^Chronic disease management:\s*/i, '')}
                                                                  </li>
                                                                ))}
                                                              </ul>
                                                            ) : (
                                                              <p className="docpro_ternary_color"><i>None</i></p>
                                                            )}
                                                          </div>
                                                          <br />
                                                        </>
                                                      )}

                                                      {/* HISTORY OF PRESENT ILLNESS */}
                                                      <div>
                                                        <div className="flex justify-between docpro_grid_gap_10">
                                                          <p className="chart_inline_copy">
                                                            <label className="docpro_mb_0">
                                                              <b> HISTORY OF PRESENT ILLNESS: </b>
                                                            </label>
                                                            <span onClick={() => copyToHtmlClipboard("present_illness_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          {can_visit('ehr_veradigm') && (
                                                            <label className="docpro_custom_toggle docpro_note_switch">
                                                              <input type="checkbox"
                                                                checked={pushEhrFlags.hpi_key ?? true}
                                                                onChange={(e) => handlePushEhrCheckboxChange("hpi_key", e.target.checked)}
                                                              />
                                                              <span className="docpro_custom_slider">
                                                                {pushEhrFlags.hpi_key 
                                                                ? <CircleCheck className="icon" />
                                                                : <CircleMinus className="icon" />
                                                                }
                                                              </span>
                                                              {pushEhrFlags.hpi_key 
                                                              ? <span className="docpro_tip">If switched off, this section <br /> will not appear in your EHR.</span>
                                                              : <span className="docpro_tip">If switched on, this section <br /> will appear in your EHR.</span>
                                                              }
                                                            </label>
                                                          )}
                                                        </div>
                                                        <div className={`present_illness_copy ${pushEhrResult && Object.keys(pushEhrResult).length > 0 ? (pushEhrResult?.hpi_status === "success" ? 'docpro_success_color' : 'docpro_error_color') : ''}`}>
                                                          {postVisitData?.history_of_present_illness ? (
                                                            typeof postVisitData?.history_of_present_illness === "string" ? (
                                                              <p>{postVisitData?.history_of_present_illness}</p>
                                                            ) : Array?.isArray(postVisitData?.history_of_present_illness) && postVisitData?.history_of_present_illness?.length > 0 ? (
                                                              postVisitData?.history_of_present_illness?.map((item, idx) => (
                                                                <span key={idx}>{item}<br /></span>
                                                              ))
                                                            ) : (
                                                              <p className="docpro_ternary_color"><i>None</i></p>
                                                            )
                                                          ) : (
                                                            <p className="docpro_ternary_color"><i>None</i></p>
                                                          )}
                                                        </div>
                                                      </div>
                                                      <br />

                                                      {/* VITAL SIGNS */}
                                                      {postVisitData?.vital_signs && Object.keys(postVisitData.vital_signs).length > 0 && (
                                                        <>
                                                          <div>
                                                            <p className="chart_inline_copy">
                                                              <b>VITAL SIGNS:</b>
                                                              <span className="pointer" onClick={() => copyToHtmlClipboard("vital_signs_copy")}>
                                                                <Copy height={14} width={14} />
                                                              </span>
                                                            </p>
                                                            <ul className="vital_signs_copy docpro_grid docpro_grid_col_3">
                                                              {Object.entries(postVisitData.vital_signs)?.map(
                                                                ([signName, signValue]) => (
                                                                  <li key={signName} className="docpro_grid_item">
                                                                    <span>{signName}: {signValue}</span>
                                                                  </li>
                                                                )
                                                              )}
                                                            </ul>
                                                          </div>
                                                          <br />
                                                        </>
                                                      )}

                                                      {/* REVIEW OF SYSTEMS */}
                                                      <div>
                                                        <div className="flex justify-between docpro_grid_gap_10">
                                                          <p className="chart_inline_copy">
                                                            <label className="docpro_mb_0">
                                                              <b> REVIEW OF SYSTEMS: </b>
                                                            </label>
                                                            <span className="pointer" onClick={() => copyToHtmlClipboard("review_of_systems_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          {(can_visit('ehr_veradigm')) &&
                                                            <label className="docpro_custom_toggle docpro_note_switch">
                                                              <input type="checkbox"
                                                                checked={pushEhrFlags.ros_key ?? true}
                                                                onChange={(e) => handlePushEhrCheckboxChange("ros_key", e.target.checked)}
                                                              />
                                                              <span className="docpro_custom_slider">
                                                                {pushEhrFlags.ros_key 
                                                                ? <CircleCheck className="icon" />
                                                                : <CircleMinus className="icon" />
                                                                }
                                                              </span>
                                                              {pushEhrFlags.ros_key 
                                                              ? <span className="docpro_tip">If switched off, this section <br /> will not appear in your EHR.</span>
                                                              : <span className="docpro_tip">If switched on, this section <br /> will appear in your EHR.</span>
                                                              }
                                                            </label>
                                                          }
                                                        </div>
                                                        {Array?.isArray(postVisitData?.review_of_systems) && postVisitData?.review_of_systems?.length > 0 ? (
                                                          <ul className={`review_of_systems_copy ${pushEhrResult && Object.keys(pushEhrResult).length > 0 ? (pushEhrResult?.ros_status === "success" ? 'docpro_success_color' : 'docpro_error_color') : ''}`}>
                                                            {postVisitData?.review_of_systems?.map((item, i) => (
                                                              <li key={i}>
                                                                <span className={`mr-2 review_of_systems_copy_${i}`}>{item}</span>
                                                                <span className="pointer" onClick={() => copyToHtmlClipboard(`review_of_systems_copy_${i}`)}>
                                                                  <Copy height={14} width={14} />
                                                                </span>
                                                              </li>
                                                            ))}
                                                          </ul>
                                                        ) : (
                                                          <p className="docpro_ternary_color"><i>None</i></p>
                                                        )}
                                                      </div>
                                                      <br />

                                                      {/* PHYSICAL EXAM */}
                                                      <div>
                                                        <div className="flex justify-between docpro_grid_gap_10">
                                                          <p className="chart_inline_copy">
                                                            <label className="docpro_mb_0">
                                                              <b> PHYSICAL EXAM: </b>
                                                            </label>
                                                            <span className="pointer" onClick={() => copyToHtmlClipboard("physical_exam_copy")}>
                                                              <Copy height={14} width={14} />
                                                            </span>
                                                          </p>
                                                          {(can_visit('ehr_veradigm')) &&
                                                            <label className="docpro_custom_toggle docpro_note_switch">
                                                              <input type="checkbox"
                                                                checked={pushEhrFlags.pe_key ?? true}
                                                                onChange={(e) => handlePushEhrCheckboxChange("pe_key", e.target.checked)}
                                                              />
                                                              <span className="docpro_custom_slider">
                                                                {pushEhrFlags.pe_key 
                                                                ? <CircleCheck className="icon" />
                                                                : <CircleMinus className="icon" />
                                                                }
                                                              </span>
                                                              {pushEhrFlags.pe_key 
                                                              ? <span className="docpro_tip">If switched off, this section <br /> will not appear in your EHR.</span>
                                                              : <span className="docpro_tip">If switched on, this section <br /> will appear in your EHR.</span>
                                                              }
                                                            </label>
                                                          }
                                                        </div>
                                                        {Array?.isArray(postVisitData?.physical_exam) && postVisitData?.physical_exam?.length > 0 ? (
                                                          <ul className={`physical_exam_copy ${pushEhrResult && Object.keys(pushEhrResult).length > 0 ? (pushEhrResult?.pe_status === "success" ? 'docpro_success_color' : 'docpro_error_color') : ''}`}>
                                                            {postVisitData?.physical_exam?.map((item, i) => (
                                                              <li key={i}>
                                                                <span className={`mr-2 physical_exam_copy_${i}`}>{item}</span>
                                                                <span className="pointer" onClick={() => copyToHtmlClipboard(`physical_exam_copy_${i}`)}>
                                                                  <Copy height={14} width={14} />
                                                                </span>
                                                              </li>
                                                            ))}
                                                          </ul>
                                                        ) : (
                                                          <p className="docpro_ternary_color"><i>None</i></p>
                                                        )}
                                                      </div>
                                                      <br />

                                                      {/* DIAGNOSIS CODE */}
                                                      <div>
                                                        <div className="flex justify-between docpro_grid_gap_10">
                                                          <p className="chart_inline_copy">
                                                            <label className="docpro_mb_0">
                                                              <b> DIAGNOSIS CODE: </b>
                                                            </label>
                                                          </p>
                                                          {(can_visit('ehr_veradigm')) &&
                                                            <label className="docpro_custom_toggle docpro_note_switch">
                                                              <input type="checkbox"
                                                                checked={pushEhrFlags.icd_key ?? true}
                                                                onChange={(e) => handlePushEhrCheckboxChange("icd_key", e.target.checked)}
                                                              />
                                                              <span className="docpro_custom_slider">
                                                                {pushEhrFlags.icd_key 
                                                                ? <CircleCheck className="icon" />
                                                                : <CircleMinus className="icon" />
                                                                }
                                                              </span>
                                                              {pushEhrFlags.icd_key 
                                                              ? <span className="docpro_tip">If switched off, this section <br /> will not appear in your EHR.</span>
                                                              : <span className="docpro_tip">If switched on, this section <br /> will appear in your EHR.</span>
                                                              }
                                                            </label>
                                                          }
                                                        </div>
                                                        {Array?.isArray(postVisitData?.icd_codes) && postVisitData?.icd_codes?.length > 0 ? (
                                                          <ol style={{ margin: 0 }}>
                                                            {postVisitData?.icd_codes.map((code, i) => {
                                                              const norm = (v) => String(v ?? "").trim().toUpperCase();
                                                              const icdCode = norm(code?.code);
                                                              const hasPush = !!pushEhrResult && Object.keys(pushEhrResult || {}).length > 0;

                                                              const icdStatusMap = hasPush && pushEhrResult?.icd_status && typeof pushEhrResult.icd_status === "object" ? pushEhrResult.icd_status : null;
                                                              const isSuccess = icdStatusMap ? icdStatusMap[icdCode] === "success" : false;
                                                              const statusClass = hasPush ? isSuccess ? "docpro_success_color" : "docpro_error_color" : "";

                                                              return (
                                                                <li key={i} className={statusClass}>
                                                                  {code?.description} <b className="mr-2">(<span className={`diagnosis_code_copy_${i}`}>{code?.code}</span>)</b>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`diagnosis_code_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                </li>
                                                              );
                                                            })}
                                                          </ol>
                                                        ) : (
                                                          <p className="docpro_ternary_color"><i>None</i></p>
                                                        )}
                                                      </div>
                                                      <br />

                                                      {/* ASSESSMENT/PLAN */}
                                                      <div>
                                                        <div className="flex justify-between docpro_grid_gap_10">
                                                          <p className="chart_inline_copy">
                                                            <label className="docpro_mb_0">
                                                              <b> ASSESSMENT/PLAN: </b>
                                                            </label>
                                                          </p>
                                                          {(can_visit('ehr_veradigm')) &&
                                                            <label className="docpro_custom_toggle docpro_note_switch">
                                                              <input type="checkbox"
                                                                checked={pushEhrFlags.assessment_key ?? true}
                                                                onChange={(e) => handlePushEhrCheckboxChange("assessment_key", e.target.checked)}
                                                              />
                                                              <span className="docpro_custom_slider">
                                                                {pushEhrFlags.assessment_key 
                                                                ? <CircleCheck className="icon" />
                                                                : <CircleMinus className="icon" />
                                                                }
                                                              </span>
                                                              {pushEhrFlags.assessment_key 
                                                              ? <span className="docpro_tip">If switched off, this section <br /> will not appear in your EHR.</span>
                                                              : <span className="docpro_tip">If switched on, this section <br /> will appear in your EHR.</span>
                                                              }
                                                            </label>
                                                          }
                                                        </div>
                                                        {Array?.isArray(postVisitData?.assessment) && postVisitData?.assessment?.length > 0 ? (
                                                          <ul>
                                                            {postVisitData?.assessment?.map((item, i) => {
                                                              const pickCode = (raw) => {
                                                                const str = String(raw ?? "");
                                                                const m = str.match(/^[A-Z]\d{1,2}[A-Z0-9]?(?:\.\d+)?/i);
                                                                return (m ? m[0] : str.split("(")[0]).trim().toUpperCase();
                                                              };
                                                              const codeOnly = pickCode(item?.icd_code);
                                                              const hasPush = !!pushEhrResult && Object.keys(pushEhrResult || {}).length > 0;

                                                              const icdStatusMap = hasPush && pushEhrResult?.icd_status && typeof pushEhrResult.icd_status === "object" ? pushEhrResult.icd_status : null;
                                                              const isSuccess = icdStatusMap ? icdStatusMap[codeOnly] === "success" : false;
                                                              const statusClass = hasPush ? isSuccess ? "docpro_green_color" : "docpro_red_color" : "";

                                                              return (
                                                                <li key={i}>
                                                                  <b className="mr-2">{item?.icd_code}</b>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                  <br />
                                                                  <span className={`assessment_plan_copy_${i} ${statusClass}`}>{item?.assessment_plan}</span>
                                                                </li>
                                                              );
                                                            })}
                                                          </ul>
                                                        ) : (
                                                          <p className="docpro_ternary_color"><i>None</i></p>
                                                        )}
                                                      </div>
                                                      <br />

                                                      {/* CPT CODES */}
                                                      <div>
                                                        <p className="chart_inline_copy">
                                                          <b>CPT CODES:</b>
                                                        </p>
                                                        {Array?.isArray(postVisitData?.cpt_codes) && postVisitData?.cpt_codes?.length > 0 ? (
                                                          <div className="docpro_table_responsive docpro_modal_cpt_codes_table">
                                                            <table
                                                              className="docpro_mb_0 docpro_primary_color docpro_modal_card_1_table_2"
                                                              style={{ minWidth: "350px" }}
                                                            >
                                                              <thead>
                                                                <tr>
                                                                  <th>Service</th>
                                                                  <th style={{ width: "90px" }}>Codes</th>
                                                                  <th style={{ width: "40px" }}></th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {postVisitData?.cpt_codes.map((item, index) => (
                                                                  <React.Fragment key={index}>
                                                                    <tr>
                                                                      <td>{item?.description || ""}</td>
                                                                      <td className={`cpt_code_copy_${index}`}>{item?.code || ""}</td>
                                                                      <td>{item?.code ? 
                                                                        <span className="pointer" onClick={() => copyToHtmlClipboard(`cpt_code_copy_${index}`)}>
                                                                          <Copy height={14} width={14} />
                                                                        </span>
                                                                      : ""}</td>
                                                                    </tr>
                                                                  </React.Fragment>
                                                                ))}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        ) : (
                                                          <p className="docpro_ternary_color"><i>None</i></p>
                                                        )}
                                                      </div>
                                                      <br />

                                                      {/* SUGGESTED SERVICES FROM PRE VISIT */}
                                                      <div>
                                                        <p className="chart_inline_copy" style={{ marginBottom: 0 }}>
                                                          <b>SUGGESTED SERVICES FROM PRE VISIT:</b>
                                                        </p>

                                                        {services?.length > 0 ? (
                                                          allKeys.length === 5 ? (
                                                            services.map((item, i) => {
                                                              return (
                                                                <div key={i} className="docpro_modal_suggested_card">
                                                                  <div className="docpro_modal_suggested_cpt_section">
                                                                    <p className="docpro_modal_suggested_cpt">
                                                                      {item?.cpt_code && (
                                                                        <><span className={`assessment_plan_copy_CPT${i}`}>{item?.cpt_code}</span>:{" "}</>
                                                                      )}
                                                                      {item?.description}
                                                                    </p>
                                                                    {item?.cpt_code && (
                                                                      <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_CPT${i}`)}>
                                                                        <Copy height={14} width={14} />
                                                                      </span>
                                                                    )}
                                                                  </div>

                                                                  <div className="docpro_modal_suggested_icd_assessment_section">
                                                                    <div className="docpro_modal_suggested_icd_section" style={{ marginBottom: "8px" }}>
                                                                      <p className="docpro_modal_suggested_icd">
                                                                        {item?.icd_code && (
                                                                          <><span className={`assessment_plan_copy_ICD${i}`}>{item?.icd_code}</span>{" "}—{" "}</>
                                                                        )}
                                                                        {item?.condition_description}
                                                                      </p>
                                                                      {item?.icd_code && (
                                                                        <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_ICD${i}`)}>
                                                                          <Copy height={14} width={14} />
                                                                        </span>
                                                                      )}
                                                                    </div>

                                                                    {item?.assessment_plan ? (
                                                                      <div className="docpro_modal_suggested_icd_section">
                                                                        <p className={`assessment_suggested_plan_copy_${i} docpro_modal_suggested_assessment_plan`}>
                                                                          {item?.assessment_plan}
                                                                        </p>
                                                                        <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_suggested_plan_copy_${i}`)}>
                                                                          <Copy height={14} width={14} />
                                                                        </span>
                                                                      </div>
                                                                    ) : (
                                                                      <p style={{ fontStyle: "italic", color: "#999" }}>No assessment plan provided.</p>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              );
                                                            })
                                                          ) : (
                                                            <ul>
                                                              {postVisitData?.potential_services_from_previsit_plan?.map((item, i) => (
                                                                <li key={i}>
                                                                  <b className="mr-2">{item?.code} {item?.description}</b>
                                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_service_plan_copy_${i}`)}>
                                                                    <Copy height={14} width={14} />
                                                                  </span>
                                                                  <br />
                                                                  <span className={`assessment_service_plan_copy_${i}`}>{item?.assessment_plan}</span>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          )
                                                        ) : (
                                                          <p style={{ fontStyle: "italic", color: "#999" }}>None</p>
                                                        )}
                                                      </div>

                                                      {singlePatientData?.clinical_note_update_time && (
                                                        <p 
                                                          className="docpro_mb_0 text-center docpro_ternary_color mt-2" 
                                                          style={{ fontWeight: 400 }}
                                                          onClick={(e) => {
                                                            if ((e.detail === 3) && singlePatientData?.t_model) {
                                                              notify("info", singlePatientData?.t_model, 2);
                                                            }
                                                          }}
                                                        >
                                                          Note generated on {singlePatientData?.clinical_note_update_time}
                                                        </p>
                                                      )}
                                                    </>
                                                  )
                                                ) : (
                                                  <p className="docpro_ternary_color">No data available</p>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          {/* <div className="docpro_modal_send_box">
                                            <textarea placeholder="Add additional details (ex: patient is pre-diabetic based on lab results)"></textarea>
                                            <div className="docpro_modal_send_box_btns">
                                              <button className="docpro_border_btn docpro_modal_send_box_btn_1">
                                                <Mic width={20} height={20} />
                                              </button>
                                              <button className="docpro_border_btn docpro_modal_send_box_btn_2">
                                                <Send width={20} height={20} />
                                              </button>
                                            </div>
                                          </div> */}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {activeTab === 2 && (
                                  <div className="docpro_tab_modal_right">
                                    <div className="docpro_tab_modal_right_in">
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {activeTab === 3 && (
                                  <div className="docpro_tab_modal_right">
                                    <div className="docpro_tab_modal_right_in">
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                      <p>
                                        Why don't you sit up on the table here
                                        and straighten out your legs. Now try to
                                        resist, and when I push down, you try to
                                        push with your feet down. Does this hurt
                                        in the knees?
                                      </p>
                                      <p>
                                        <b>
                                          Yes, it does hurt. I cannot resist
                                          with full power.
                                        </b>
                                      </p>
                                      <p>
                                        Okay, now let your legs loose, and now
                                        resist as I try to pull your legs up.
                                        Does that hurt?
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {activeTab === 4 && (
                                  <div className="docpro_tab_modal_right">
                                    <div className="docpro_tab_modal_right_in">
                                      <div className="cs_recording_animation_wrap">
                                        <div className="cs_recording_animation">
                                          <div className="voice-waveform">
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                            <div className="bar" />
                                          </div>
                                        </div>
                                        <svg
                                          width={199}
                                          height={134}
                                          viewBox="0 0 199 134"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g filter="url(#filter0_f_2863_2999)">
                                            <rect
                                              x={40}
                                              y={50}
                                              width={49}
                                              height={32}
                                              rx={16}
                                              fill="#ACC7FF"
                                            />
                                          </g>
                                          <g filter="url(#filter1_f_2863_2999)">
                                            <rect
                                              x={110}
                                              y={50}
                                              width={49}
                                              height={32}
                                              rx={16}
                                              fill="#ACC7FF"
                                            />
                                          </g>
                                          <g
                                            style={{ mixBlendMode: "overlay" }}
                                            filter="url(#filter2_f_2863_2999)"
                                          >
                                            <rect
                                              x={50}
                                              y={40}
                                              width={83}
                                              height={54}
                                              rx={27}
                                              fill="#00FF37"
                                            />
                                          </g>
                                          <defs>
                                            <filter
                                              id="filter0_f_2863_2999"
                                              x={0}
                                              y={10}
                                              width={129}
                                              height={112}
                                              filterUnits="userSpaceOnUse"
                                              colorInterpolationFilters="sRGB"
                                            >
                                              <feFlood
                                                floodOpacity={0}
                                                result="BackgroundImageFix"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                              />
                                              <feGaussianBlur
                                                stdDeviation={20}
                                                result="effect1_foregroundBlur_2863_2999"
                                              />
                                            </filter>
                                            <filter
                                              id="filter1_f_2863_2999"
                                              x={70}
                                              y={10}
                                              width={129}
                                              height={112}
                                              filterUnits="userSpaceOnUse"
                                              colorInterpolationFilters="sRGB"
                                            >
                                              <feFlood
                                                floodOpacity={0}
                                                result="BackgroundImageFix"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                              />
                                              <feGaussianBlur
                                                stdDeviation={20}
                                                result="effect1_foregroundBlur_2863_2999"
                                              />
                                            </filter>
                                            <filter
                                              id="filter2_f_2863_2999"
                                              x={10}
                                              y={0}
                                              width={163}
                                              height={134}
                                              filterUnits="userSpaceOnUse"
                                              colorInterpolationFilters="sRGB"
                                            >
                                              <feFlood
                                                floodOpacity={0}
                                                result="BackgroundImageFix"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="BackgroundImageFix"
                                                result="shape"
                                              />
                                              <feGaussianBlur
                                                stdDeviation={20}
                                                result="effect1_foregroundBlur_2863_2999"
                                              />
                                            </filter>
                                          </defs>
                                        </svg>
                                      </div>
                                      <div className="cs_recording_animation_text">
                                        <Clock width={16} height={16} />
                                        Recording… (00:01:23)
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="docpro_grid docpro_grid_col_2 docpro_previsit">
                      <div className="docpro_grid_item docpro_patient_body_left">
                        <div className="docpro_patient_head_2_border">
                          <div className="docpro_patient_head_2 patient_head_1_border">
                            <div className="docpro_media">
                              <Skeleton width="3.5rem" height="3.5rem" borderRadius="50%"></Skeleton>
                              <div className="docpro_media_right">
                                <h2 className="docpro_fs_20 docpro_text_uppercase">
                                  <Skeleton width="10rem" height="1.2rem" borderRadius="8px"></Skeleton>
                                </h2>
                                <Skeleton width="8rem" borderRadius="8px"></Skeleton>
                              </div>
                            </div>
                            <div className="docpro_patient_head_buttons_wrap">
                              <div className="docpro_patient_head_buttons relative">
                                <Skeleton width="100%" height="2rem" borderRadius="8px"></Skeleton>
                                <div className="docpro_patient_head_buttons_in">
                                  <Skeleton width="8rem" height="2rem" borderRadius="8px"></Skeleton>
                                  <Skeleton width="8rem" height="2rem" borderRadius="8px"></Skeleton>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="docpro_patient_head_2 patient_head_2_border">
                            <div className="docpro_patient_head_info_list">
                              <ul>
                                <li>
                                  <b>Gender: </b>
                                  <Skeleton width="70px" borderRadius="8px"></Skeleton>
                                </li>
                                <li>
                                  <b>Insurance: </b>
                                  <Skeleton width="100px" borderRadius="8px"></Skeleton>
                                </li>
                                <li>
                                  <b>DOB: </b>
                                  <Skeleton width="70px" borderRadius="8px"></Skeleton>
                                </li>
                              </ul>
                              <ul className="small_screen_display_hide">
                                <li>
                                  <b>DOS: </b>
                                  <Skeleton width="70px" borderRadius="8px"></Skeleton>
                                </li>
                                <li>
                                  <b>Last annual wellness visit: </b>
                                  <Skeleton width="70px" borderRadius="8px"></Skeleton>
                                </li>
                                <li>
                                  <b>Last hospitalization date: </b>
                                  <Skeleton width="70px" borderRadius="8px"></Skeleton>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="docpro_patient_body_2 small_screen_display_hide">
                          <div className={`docpro_patient_body_2_left ${visitActive === "post_visit" ? " post_visit_active" : "" }`}>
                            <div className="docpro_tab_wrap">
                              <div className="docpro_tab">
                                <button type="button"
                                  className={`docpro_tab_item ${visitActive === "pre_visit" ? "active" : ""}`}
                                  onClick={() => setVisitActive("pre_visit")}
                                >
                                  Pre-visit
                                </button>
                                {!can_visit('ehr_veradigm') && (
                                  <button type="button"
                                    className={`docpro_tab_item ${visitActive === "during_visit" ? "active" : ""}`}
                                    onClick={() => { setVisitActive("during_visit"); }}
                                  >
                                    During visit
                                  </button>
                                )}
                              </div>
                              <hr />
                            </div>

                            {visitActive === "pre_visit" && (
                              <div className="docpro_modal_card_1_wrap_overflow custom-scroll">
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Pending QM </div>
                                  <div className="docpro_modal_card_1_body">
                                    <div className="flex items-center justify-between">
                                      <Skeleton width="8rem" height="1.5rem" borderRadius="8px"></Skeleton>
                                      <Skeleton width="8rem" height="1.5rem" borderRadius="8px"></Skeleton>
                                      <Skeleton width="8rem" height="1.5rem" borderRadius="8px"></Skeleton>
                                    </div>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Chronic conditions </div>
                                  <div className="docpro_modal_card_1_body">
                                    <div className="flex items-center justify-between">
                                      <Skeleton width="8rem" height="2rem" borderRadius="8px"></Skeleton>
                                      <Skeleton width="8rem" height="2rem" borderRadius="8px"></Skeleton>
                                      <Skeleton width="8rem" height="2rem" borderRadius="8px"></Skeleton>
                                    </div>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Last 3 visits summary </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="90%" borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                    <Skeleton width="70%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Screening Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="80%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="60%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> EM Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="80%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Counseling Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="75%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Procedure Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="65%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> HCC Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="85%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> For Televisit </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="40%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="50%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> For Post Hospital </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="65%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="90%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                              </div>
                            )}
                            {visitActive === "during_visit" && (
                              <div className="docpro_modal_card_1_wrap_overflow custom-scroll">
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Questions </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Screening Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="80%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="60%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> EM Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="80%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Counseling Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="75%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> Procedure Codes </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="65%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> For Televisit </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="40%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="50%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                                <div className="docpro_modal_card_1">
                                  <div className="docpro_modal_card_1_head docpro_fw_700"> For Post Hospital </div>
                                  <div className="docpro_modal_card_1_body">
                                    <Skeleton width="65%" borderRadius="8px" className="mb-2"></Skeleton>
                                    <Skeleton width="90%" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="docpro_grid_item">
                        <div className="docpro_patient_body_2 small_screen_display_hide">
                          <div className="docpro_patient_body_2_right">
                            <div className="docpro_modal_card_2">
                              <div className="docpro_tab_wrap" style={{ borderBottom: "1px solid #ddd" }}>
                                <div className="docpro_tab">
                                  <button type="button" className={`docpro_tab_item audit_report ${activeTab === 0 ? "active" : ""}`} onClick={() => {setActiveTab(0);}}>
                                    <Speech width={17} height={17} color="#7e808a" /> Doctor's input
                                  </button>
                                  <button type="button" className={`docpro_tab_item audit_report ${activeTab === 1 ? "active" : ""}`} onClick={() => {setActiveTab(1);}}>
                                    <FileText width={16} height={16} color="#7e808a" /> Note
                                  </button>
                                </div>
                                <hr />
                              </div>
                              {activeTab === 0 && (
                                <div className="docpro_tab_modal_right">
                                  <div className="docpro_tab_modal_right_in relative">
                                    <Skeleton height="calc(100% - 50px)" borderRadius="8px"></Skeleton>
                                    <Skeleton height="2.5rem" borderRadius="8px"></Skeleton>
                                  </div>
                                </div>
                              )}
                              {activeTab === 1 && (
                                <div className="docpro_tab_modal_right" style={{ padding: "0 0 10px 0" }}>
                                  <div className="docpro_tab_modal_right_in">
                                    <div className="py-2 px-3">
                                      <div className="flex items-center justify-between mb-2">
                                        <Skeleton width="8rem" height="2.5rem" borderRadius="8px"></Skeleton>
                                        <Skeleton width="8rem" height="2.5rem" borderRadius="8px"></Skeleton>
                                        <Skeleton width="8rem" height="2.5rem" borderRadius="8px"></Skeleton>
                                      </div>
                                      <p className="mb-1"><b>REASON FOR VISIT:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                      <p className="mb-1"><b>HISTORY OF PRESENT ILLNESS:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                      <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                      <p className="mb-1"><b>REVIEW OF SYSTEMS:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                      <Skeleton width="80%" borderRadius="8px" className="mb-2"></Skeleton>
                                      <Skeleton width="60%" borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                      <p className="mb-1"><b>PHYSICAL EXAM:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                      <p className="mb-1"><b>DIAGNOSIS CODE:</b></p>
                                      <Skeleton width="50%" borderRadius="8px" className="mb-2" count={3}></Skeleton>
                                      <p className="mb-1"><b>ASSESSMENT/PLAN:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2" count={3}></Skeleton>
                                      <p className="mb-1"><b>CPT CODES:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                      <Skeleton width="60%" borderRadius="8px" className="mb-2"></Skeleton>
                                      <p className="mb-1"><b>SUGGESTED SERVICES FROM PRE VISIT:</b></p>
                                      <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                      <Skeleton width="60%" borderRadius="8px" className="mb-2"></Skeleton>
                                      <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                      <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>

      {showEHRPushWarning && (
        <SendEHRConfirm
          activeModal={showEHRPushWarning}
          ehrSendDate={singlePatientData?.ehr_sent_data_time_date_only}
          onCancel={() => {
            setShowEHRPushWarning(false);
          }}
          onConfirm={() => {
            setShowEHRPushWarning(false);
            uploadToEHR(true);
          }}
        />
      )}

      {viewNoteModal && (
        <AuditReportNoteViewModal
          openModal={viewNoteModal}
          setOpenModal={setViewNoteModal}
          setOpacityClass={setOpacityClass}
          transcription={transcription}
          postVisitData={postVisitData}
          postvisitLoader={postvisitLoader}
          previousScrollPosition={previousScrollPosition}
          handleGenerateNote={handleGenerateNote}
          disabledNoteGenerate={disabledNoteGenerate}
          handleTranscriptChange={handleTranscriptChange}
          services={services}
          allKeys={allKeys}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}
    </>
  );
}
